export enum MessagingType {
  Email = 'email',
  SMS = 'sms',
  Courrier = 'courrier'
}
